export const DEFAULT_ZOOM = 7.8;
export const ZOOM_SHOW_INFO_WINDOW = 9;
export const ZOOM_SHOW_VOLUNTEERS = 12.5;
export const DEFAULT_CENTER = { lat: 31.35, lng: 35 };

/** Map pin z-index: opportunities always above volunteers so missions stay visible. */
export const MAP_PIN_ZINDEX_VOLUNTEER_LAYER = 1000;
export const MAP_PIN_ZINDEX_OPPORTUNITY_LAYER = 2000;
export const MAP_PIN_ZINDEX_HOVERED_VOLUNTEER = 9998;
export const MAP_PIN_ZINDEX_HOVERED_OPPORTUNITY = 9999;
